import moment from 'moment';
import { Div, RefObject, Span, Image } from '@tblabs/truffle';
import { BlobPicture } from "../Models/BlobPicture";
import { ImageInfo } from '@tblabs/truffle';
import { BlobUtils } from '../Utils/BlobUtils';


export class PreviewBox extends Div
{
    private previewImage = new Image().PositionRelative();
    private infoLabel = new Span().Class("image-info")
    private noPreviewLabel: Div;
    private timestampLabel = new Span().Class("image-timestamp")

    constructor(inputStream: RefObject<BlobPicture | null>)
    {
        super("preview-box")

        this.noPreviewLabel = new Div("preview-box-label pulse")
            .Text("Uruchamianie...")

        inputStream.OnChange(async (picture: BlobPicture | null) =>
        {
            if (picture)
            {
                const base64 = await BlobUtils.BlobToBase64(picture.Image);
                this.previewImage.Src(base64);

                this.timestampLabel.Text(moment(picture.PictureTime).format("DD.MM.YYYY HH:mm:ss"));
            }
        });

        this.previewImage.OnInfoReady.Subscribe((info: ImageInfo) =>
        {
            const size = info.Size / 1024;
            this.infoLabel.Text(info.Width + "×" + info.Height + "px, " + size.toFixed(1) + "kb");
        });

        this.Append(
            this.previewImage,
            this.infoLabel,
            this.timestampLabel);

        if (this.previewImage.IsEmpty)
        {
            this.Append(this.noPreviewLabel)
        }
    }
}
